import { css } from '@emotion/css';
import Button from 'components/button/Button';
import { animationShowHide, glassEffect } from 'constants/global.style';
import { colors } from 'constants/theme';
import { Game3rdMenuItem } from 'models/commonModel';
import imageDefault from 'assets/images/promo-default.png';
import { tryImg } from 'utils/safeImage';
import React from 'react';

interface Props {
    gameList: Game3rdMenuItem[];
    onSelect: (game: Game3rdMenuItem) => void;
    gametype: string;
}

function LiveCasinoSection(props: Props) {
    const { gameList, onSelect, gametype } = props;

    return (
        <div className={styles.gameWrap}>
            <div className={styles.gameRight}>
                {gameList.map((game, index) => (
                    <React.Fragment key={game.providercode}>
                        
                            <div className={`${styles.gameItem} ${styles.liveGameItem}`} key={game.providercode}>
                                <img className="bg-game" src={tryImg(() => require(`assets/images/game-card/${gametype}/${game.iconpc}.png`)) || imageDefault} alt="" />
                                <div className={styles.btnPlayGame}>
                                    <Button text="CHƠI NGAY" weight="bold" textColor={colors.black} bg={colors.btnplay} click={() => onSelect(game)} borderColor={colors.orange} rounded bgHover={colors.orange} textSize="16px" />
                                </div>
                            </div>
                        
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
}

const styles = {
    gameWrap: css`
        display: flex;
        gap: 28px;
    `,
    gameRight: css`
        display: flex;
        flex-wrap: wrap;
        row-gap: 8px;
        margin: 0 auto;
        width: 100%;
        justify-content: center;
    `,
    liveGameItem: css`
        flex: 0 0 25%;
        max-width: 25%;
        padding: 5px;
        padding-bottom: 0;
        .bg-game {
            width: 100%;
        }
    `,
    ownGame: css`
        flex: 0 0 50%;
        width: 50%;
        padding: 4px 12px;
        .bg-game {
            width: 100%;
        }
        .game-content {
            position: absolute;
            top: 32px;
            left: 12px;
            height: calc(100% - 48px);
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding-left: 16px;
            > img {
                width: 170px;
            }
        }
        .game-game {
            font-size: 28px;
            font-weight: 600;
            color: ${colors.white};
            margin-top: 8px;
        }
        .btn-play {
            margin-top: 40px;
            display: flex;
            align-items: center;
            gap: 16px;
        }
        &.active {
            .bg-game {
                animation: ${animationShowHide} 0.8s linear infinite;
            }
        }
    `,
    gameItem: css`
        position: relative;
        height: fit-content;
        transition: border-radius 650ms ease-in-out;
        /* overflow: hidden; */
        .logo-game {
            position: absolute;
            left: 28px;
            top: 40px;
            width: 100px;
        }
        &::before {
            position: absolute;
            content: '';
            width: 130%;
            height: calc(100% - 15px);
            top: 15px;
            left: -10%;
            background: linear-gradient(120deg, transparent 0%, transparent 20%, rgba(255, 255, 255, 0.2) 21%, rgba(255, 255, 255, 0.5) 35%, transparent 36%);
            background-size: 160%;
            background-position: 120%;
            /* opacity: 0; */
            pointer-events: none;
            border-radius: 12px;
        }
        &:hover {
            &::before {
                cursor: pointer;
                animation: ${glassEffect} 650ms ease-in-out;
            }
        }
    `,
    btnPlayGame: css`
        position: absolute;
        left: 28px;
        bottom: 26px;
    `,
    logoOwnGame: css`
        display: flex;
        align-items: flex-end;
        gap: 12px;
        > img {
            width: 170px;
        }
    `,
    iconHot: css`
        width: 30px;
    `,
    labelHot: css`
        position: absolute;
    `,
};

export default LiveCasinoSection;
